import { renderInDocument } from '@spotahome/soyuz/client';

import Alerts from './main';

renderInDocument(Alerts);
